import type React from "react"
import { useState } from "react"
import { Button, Tooltip } from "antd"
import { StarTwoTone , RobotOutlined,ThunderboltOutlined } from "@ant-design/icons"
import { AITagGenerationWizard } from "components"

interface errorObject {
    message: string
    code: string
    success: boolean
  }
interface AIGenerateTagButtonProps {
    generateTagsWithAI: (
        payload:{ prompt: string, numTags: number }
    ) => Promise<Array<{ name: string; description: string }>>
    createTags?: (
        tags: Array<{ tagName: string; tagDescription: string; businessAreaId: string }>
    ) => Promise<void>
    isGeneratingTags: boolean
    isCreatingTags: boolean
    businessAreaList: Array<{ businessAreaId: string; name: string }>
    aiGeneratedTags?: any
    resetAiGeneratedTags?: () => void;
    disabled?: boolean
    openAIKeyExists?: boolean
    aiGeneratedErrors?: errorObject | null
    bulkCreateErrors?: errorObject | null
    DataTagList?:Array<any>
    rephraseWithAI?: (payload:{tagName:string,prevDescription:string}) => Promise<{newDescription:string}>
    isRephrasing?: boolean
    rephrasedDataTag?:any
}

const AIGenerateTagButton: React.FC<AIGenerateTagButtonProps> = ({
    generateTagsWithAI,
    createTags,
    isGeneratingTags,
    isCreatingTags,
    businessAreaList,
    aiGeneratedTags,
    resetAiGeneratedTags,
    openAIKeyExists,
    disabled,
    aiGeneratedErrors,
    bulkCreateErrors,
    DataTagList,
    rephraseWithAI,
    isRephrasing,
    rephrasedDataTag,
}) => {
    const [wizardVisible, setWizardVisible] = useState(false)

    const showWizard = () => {
        setWizardVisible(true)
    }
    const hideWizard = () => {
        setWizardVisible(false)
    }
    return (
        <>
            <Tooltip title={`${!openAIKeyExists ? 'OpenAI API key required (Bring Your Own License - BYOL). Please configure your key in settings' : 'Generate tags with AI'}`} overlayClassName="font-semibold">
    <Button
        type="default"
        onClick={showWizard}
        className="relative overflow-hidden group border-none h-11 rounded-3xl  px-6 shadow-lg hover:shadow-2xl transition-all duration-300 bg-[#0D1117]"
        disabled={disabled|| !openAIKeyExists}
    >
    <div className={`absolute inset-0 bg-gradient-to-br ${disabled|| !openAIKeyExists ? 'from-slate-400 to-slate-500 opacity-50' : 'from-[#3b82f6] via-[#6366f1] via-60% to-[#a855f7] to-90% bg-size-200 opacity-90 group-hover:opacity-100 animate-gradientBg'} transition-opacity duration-300`}></div>
        <div className="absolute -inset-1 bg-gradient-radial from-[#a855f7]/40 via-[#6366f1]/30 to-transparent opacity-50 blur-lg group-hover:opacity-70 group-hover:blur-xl transition-all duration-300 rounded-xl"></div>
            <div className="relative flex items-center gap-2.5 z-10">
            <div className="absolute -inset-0.5 w-10 h-10 rounded-full bg-indigo-400 opacity-30 animate-ping"></div>  
                    <StarTwoTone twoToneColor="#a78bfa" className="text-2xl " />
                <span className="font-bold text-white tracking-wide relative">
                Generate with AI
                </span>
        </div>      
    </Button>
    </Tooltip>
            <AITagGenerationWizard
                visible={wizardVisible}
                onClose={hideWizard}
                generateTagsWithAI={generateTagsWithAI}
                createTags={createTags}
                isGeneratingTags={isGeneratingTags}
                isCreatingTags={isCreatingTags}
                businessAreaList={businessAreaList}
                aiGeneratedTags={aiGeneratedTags}
                resetAiGeneratedTags={resetAiGeneratedTags}
                aiGeneratedErrors={aiGeneratedErrors}
                bulkCreateErrors={bulkCreateErrors}
                DataTagList={DataTagList}
                rephraseWithAI={rephraseWithAI}
                isRephrasing={isRephrasing}
                rephrasedDataTag={rephrasedDataTag}
            />
        </>
    )
}

export default AIGenerateTagButton